import "./Bar.css";

function Bar() {
    return (
        <span className="bar"></span>
    );
}

export default Bar;
